import {
  Container,
  Box,
  Grid,
  TextField,
  Typography,
  CircularProgress,
  Divider,
  Stepper,
  Step,
  StepLabel,
} from 'app/design';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useForm, FormProvider } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import Joi from 'joi';
import { useAuthSelector, useAuthSlice } from 'app/data/auth';
import { useGlobalTour } from 'app/components/Tourguide/Helper';

import { useAuthenticatedUserQuery } from 'app/hooks/queries/user';
// import { ActivateAccount } from './ActivateAccount';
// import { ScheduleOpenTimes } from './ScheduleOpenTimes';
// import { ScheduleLunchTimes } from './ScheduleLunchTimes';
// import { ScheduleHolidayTimes } from './ScheduleHolidayTimes';
// import { EmergencyRouting } from './EmergencyRouting';
// import { LunchEmergencyRouting } from './LunchEmergencyRouting';
// import { ClosedEmergencyRouting } from './ClosedEmergencyRouting';
// import { OpenMenu } from './OpenMenu';
// import { Operator } from './Operator';
// import { UsersDirect } from './UsersDirect';
// import { UsersAdd } from './UsersAdd';
// import { PublicNumbers } from './PublicNumbers';
// import { Save } from './Save';
import {
  User as UserIcon,
  Phone as PhoneIcon,
  CreditCard as CreditCardIcon,
} from 'iconoir-react';
import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
import { Fragment, ReactElement, ReactNode } from 'react';
import { Transition } from '@headlessui/react';
import { current } from '@reduxjs/toolkit';
import { Button } from 'app/design-lib';
import { RouterLink } from 'app/components/RouterLink';
import { Link } from 'react-router-dom';
import { ResetOnboarding } from 'app/pages/settings/Settings/Settings';
import useDevMode from 'app/utilities/useDevMode';

const schema = Joi.object({
  first_name: Joi.string().required(),
  last_name: Joi.string().required(),
  companyName: Joi.string().required(),
});

interface VsbInput {
  // username: string;
  // account_name: string;
  // password: string;
}

// interface VsbProps {
//   // credentials?: {
//   //   username: string;
//   //   account_name: string;
//   //   password: string;
//   // };
// }

const Vsb = () => {
  // const { loggingIn, loggedIn, username, account_name, error } =
  //   useAuthSelector();
  // const { actions: authActions } = useAuthSlice();
  // const dispatch = useDispatch();
  // const onSubmit = VsbInputData => {
  //   dispatch(authActions.loginWithCredentials(VsbInputData));
  // };

  const {
    data: userData,
    isLoading: userIsLoading,
    error: userError,
  } = useAuthenticatedUserQuery();
  const { devMode, toggleDevMode } = useDevMode();

  const methods = useForm<VsbInput>({
    defaultValues: {
      prefix: '', // will get sorted out in Step 1! (after the address is figured out)
      activeStep: 0,
      prevStep: 0,
      transitionToStep: 0,
      first_name: '',
      last_name: '',
      companyName: '',
      address: null,
      verified: false,
      // username: username ?? credentials?.username ?? '',
      // account_name: account_name ?? credentials?.account_name ?? '',
      // password: credentials?.account_name ? credentials?.password : '',
    },
    mode: 'onChange',
    resolver: joiResolver(schema),
  });

  // console.log('methods', methods.formState.errors);
  // {
  //   register,
  //   handleSubmit,
  //   formState: { errors: formErrors, isValid },
  // }

  //@ts-ignore
  const activeStep = methods.watch('activeStep', 0) as Number;
  //@ts-ignore
  const prevStep = methods.watch('prevStep', 0) as Number;

  return (
    <FormProvider {...methods}>
      {/* prevent card from submitting form when enter is pressed */}
      <form onSubmit={e => e.preventDefault()} className={`overflow-y-auto`}>
        <Transition
          as={Fragment}
          show
          appear
          enter="ease-out transition-opacity duration-1000"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-500"
          leaveFrom="opacity-100 "
          leaveTo="opacity-0"
        >
          <div className={'h-screen w-screen flex sm:flex-row flex-col'}>
            <div
              className={`sm:w-1/2 z-10 sm:h-full flex-[2] sm:flex-1 flex flex-col bg-accent-90 text-white px-6 pt-4 pb-4 sm:pb-3`}
            >
              <svg
                width="171"
                height="40"
                viewBox="0 0 171 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.84152 5.86836C2.92673 8.77781 0.988594 12.5209 0.295288 16.5798H3.78829C4.40323 13.659 5.79608 10.9586 7.81963 8.76387C9.84319 6.56914 12.4223 4.96164 15.2844 4.11125C18.1464 3.26085 21.1852 3.19916 24.0794 3.93269C26.9737 4.66623 29.6159 6.16773 31.727 8.27853C33.838 10.3893 35.3394 13.031 36.0724 15.9244C36.8055 18.8178 36.743 21.8554 35.8915 24.7162C35.0401 27.577 33.4314 30.1547 31.2353 32.177C29.0392 34.1992 26.3375 35.5909 23.4155 36.2048V39.6966C26.5142 39.1593 29.4425 37.8993 31.9627 36.0187C34.483 34.1381 36.5241 31.69 37.9204 28.873C39.3167 26.0561 40.0289 22.9497 39.9991 19.806C39.9694 16.6624 39.1985 13.57 37.749 10.78C36.2996 7.98996 34.2125 5.5809 31.6571 3.74835C29.1017 1.91581 26.15 0.711413 23.0417 0.23294C19.9334 -0.245533 16.756 0.0153975 13.7675 0.994552C10.7789 1.97371 8.06348 3.64349 5.84152 5.86836ZM15.542 24.4514C16.4208 25.3315 17.541 25.9311 18.7609 26.1745C19.9808 26.4179 21.2455 26.2941 22.3949 25.8188C23.5444 25.3434 24.527 24.5379 25.2183 23.5041C25.9096 22.4704 26.2786 21.2548 26.2786 20.0113C26.2786 18.7679 25.9096 17.5523 25.2183 16.5185C24.527 15.4848 23.5444 14.6792 22.3949 14.2039C21.2455 13.7285 19.9808 13.6047 18.7609 13.8481C17.541 14.0915 16.4208 14.6912 15.542 15.5713C14.367 16.7505 13.7072 18.347 13.7072 20.0113C13.7072 21.6757 14.367 23.2722 15.542 24.4514ZM17.9673 22.0286C17.5676 21.6291 17.2953 21.1201 17.185 20.566C17.0747 20.0118 17.1313 19.4374 17.3476 18.9153C17.5638 18.3933 17.9301 17.9471 18.4001 17.6332C18.8701 17.3193 19.4226 17.1517 19.9878 17.1517C20.5531 17.1517 21.1056 17.3193 21.5756 17.6332C22.0456 17.9471 22.4118 18.3933 22.6281 18.9153C22.8444 19.4374 22.901 20.0118 22.7906 20.566C22.6803 21.1201 22.4081 21.6291 22.0084 22.0286C21.472 22.5634 20.7454 22.8638 19.9878 22.8638C19.2303 22.8638 18.5036 22.5634 17.9673 22.0286ZM29.1668 23.242C28.6779 24.6108 27.8882 25.8525 26.8556 26.8757C25.8792 27.8498 24.7052 28.6034 23.4129 29.0857V32.6796C25.641 32.0817 27.6725 30.9082 29.3032 29.277C30.9339 27.6458 32.1065 25.6143 32.7032 23.3866C33.2998 21.1589 33.2995 18.8135 32.7022 16.586C32.105 14.3585 30.9318 12.3273 29.3006 10.6965C27.6694 9.06576 25.6376 7.89282 23.4093 7.29554C21.1811 6.69827 18.8348 6.6977 16.6062 7.29389C14.3777 7.89008 12.3453 9.06203 10.7133 10.692C9.08134 12.322 7.90719 14.3526 7.30885 16.5798H10.9024C11.4103 15.218 12.2173 13.9873 13.264 12.9785C14.3106 11.9698 15.5703 11.2085 16.9503 10.7509C18.3303 10.2932 19.7954 10.1508 21.2377 10.3341C22.68 10.5175 24.0629 11.0219 25.2843 11.8102C26.5058 12.5985 27.5349 13.6507 28.2957 14.8892C29.0565 16.1277 29.5297 17.5211 29.6805 18.9667C29.8312 20.4122 29.6557 21.8732 29.1668 23.242Z"
                  fill="white"
                />
                <path
                  d="M11.9913 33.9141C11.879 34.0262 11.7319 34.0969 11.5742 34.1145C11.4164 34.1322 11.2574 34.0958 11.123 34.0113C9.04949 32.6989 7.29224 30.944 5.97739 28.8725C5.89285 28.7382 5.85643 28.5793 5.87409 28.4216C5.89176 28.2639 5.96245 28.1169 6.0746 28.0046L7.86804 26.2119C7.96871 26.1111 8.03627 25.9821 8.06173 25.842C8.08718 25.7019 8.06931 25.5574 8.01051 25.4277C7.33571 23.9288 6.94581 22.3175 6.8607 20.676C6.85376 20.4959 6.77725 20.3254 6.64723 20.2004C6.51721 20.0754 6.34381 20.0057 6.16344 20.0058H0.701005C0.606912 20.006 0.513813 20.0251 0.427237 20.0619C0.34066 20.0987 0.262372 20.1526 0.197021 20.2203C0.13167 20.2879 0.0805892 20.3681 0.0468115 20.4558C0.0130338 20.5436 -0.00275189 20.6373 0.000392193 20.7313C0.179385 25.7828 2.26626 30.579 5.84085 34.1542C9.41544 37.7293 14.2123 39.8179 19.2656 39.9995C19.3597 40.0031 19.4536 39.9876 19.5417 39.954C19.6297 39.9204 19.71 39.8694 19.7778 39.804C19.8456 39.7386 19.8995 39.6601 19.9362 39.5734C19.9729 39.4866 19.9916 39.3933 19.9913 39.2991V36.5781V33.8253C19.9911 33.6449 19.9212 33.4716 19.7963 33.3415C19.6714 33.2113 19.5011 33.1344 19.3209 33.1266C17.6782 33.0429 16.0656 32.6537 14.5658 31.9789C14.4363 31.92 14.292 31.9021 14.1521 31.9275C14.0122 31.953 13.8834 32.0206 13.783 32.1213L11.9913 33.9141Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M91.2703 7H94.8088V28.3592H91.2703V7ZM88.2573 7.09635H84.7187V28.4555H88.2573V7.09635ZM51.7663 18.1185C51.7663 22.1263 54.6031 25.3751 58.5218 25.3751C61.0372 25.3751 62.6398 24.3798 64.4065 22.7429L66.7159 25.0886C64.5824 27.3119 62.2412 28.716 58.4113 28.716C52.4445 28.716 48 24.0648 48 18.1839V18.1252C48 12.3029 52.3541 7.53275 58.5503 7.53275C62.3233 7.53275 64.6042 8.84298 66.5635 10.7162L64.2542 13.3785C62.6147 11.8572 60.8663 10.8318 58.5218 10.8318C54.6316 10.8318 51.7663 14.0521 51.7663 18.0599V18.1185ZM69.1688 13.9631C70.9883 13.1046 72.9801 12.6742 74.9915 12.7048C77.3009 12.7048 79.0258 13.3197 80.0942 14.4322C81.243 15.5431 81.7688 17.1817 81.7688 19.2007V28.3589H78.3174V26.4271C77.2707 27.6853 75.6614 28.6806 73.2934 28.6806C70.398 28.6806 67.824 27.0135 67.824 23.9105V23.8535C67.824 20.5176 70.4264 18.879 74.1994 18.879C75.6096 18.865 77.0126 19.0823 78.3526 19.5224V19.142C78.3526 16.9505 77.0061 15.7776 74.521 15.7776C72.7961 15.7776 71.5083 16.158 70.1049 16.7427L69.1688 13.9631ZM74.2882 26.1104C76.6277 26.1104 78.4128 24.765 78.4128 22.8046L78.4162 21.7457C77.2912 21.3279 76.0993 21.1195 74.8994 21.1308C72.6135 21.1308 71.2738 22.0976 71.2738 23.7061V23.7647C71.2738 25.2626 72.5934 26.1104 74.2882 26.1104ZM101.542 7.1757H97.7401V10.5401H101.542V7.1757ZM97.8871 12.9092H101.426V28.3589H97.8871V12.9092ZM112.766 12.5843C110.368 12.5843 108.934 13.8426 107.941 15.2768V12.9094H104.402V28.3591H107.941V19.6465C107.941 17.2472 109.373 15.813 111.421 15.813C113.526 15.813 114.725 17.1886 114.725 19.5879V28.3658H118.263V18.4988C118.263 14.93 116.246 12.5843 112.766 12.5843ZM132.6 15.2215V12.9094H136.138V25.1924C136.138 27.7961 135.465 29.7263 134.179 31.0147C132.774 32.4221 130.61 33.0923 127.832 33.0923C125.407 33.1191 123.02 32.4818 120.931 31.2493L122.247 28.5853C123.913 29.6107 125.638 30.2239 127.745 30.2239C130.903 30.2239 132.628 28.5853 132.628 25.4856V24.2876C131.342 25.9531 129.733 27.1259 127.189 27.1259C123.563 27.1259 120.17 24.4351 120.17 19.8995V19.8409C120.17 15.2768 123.592 12.5843 127.189 12.5843C129.793 12.5843 131.401 13.7873 132.6 15.2215ZM128.125 24.1167C130.582 24.1167 132.657 22.3876 132.657 19.8744V19.8157C132.657 17.2991 130.582 15.5734 128.125 15.5734C125.668 15.5734 123.737 17.269 123.737 19.8157V19.8744C123.737 22.3893 125.697 24.1167 128.125 24.1167Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M146.268 18.1186C146.268 12.355 150.712 7.52618 157 7.52618C163.285 7.52618 167.675 12.2963 167.675 18.06V18.1186C167.675 23.8823 163.23 28.7094 156.942 28.7094C150.653 28.7094 146.268 23.941 146.268 18.1773V18.1186ZM157 25.3819C161.065 25.3819 163.902 22.1566 163.902 18.1773V18.1136C163.902 14.1343 160.998 10.8269 156.942 10.8269C152.886 10.8269 150.039 14.0757 150.039 18.055V18.1136C150.039 22.0979 152.936 25.3819 157 25.3819ZM139.684 7.87811H143.281V28.3593H139.684V7.87811Z"
                  fill="white"
                />
              </svg>
              <div className={`flex-grow grid place-items-center px-2`}>
                <div
                  className={`w-full flex flex-col space-y-2 sm:space-y-6 px-8 sm:px-16`}
                >
                  <Transition
                    show={!!userData}
                    appear
                    as={Fragment}
                    enter="ease-out transition-opacity delay-[1000ms] duration-[6000ms]"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-500"
                    leaveFrom="opacity-100 "
                    leaveTo="opacity-0"
                  >
                    <div
                      onDoubleClick={toggleDevMode}
                      className={`text-3xl sm:text-6xl font-medium`}
                    >
                      Welcome!
                      {/* {userData?.doc.first_name} */}
                      {devMode ? <ResetOnboarding /> : null}
                    </div>
                  </Transition>
                  <div className={`relative h-[29px]`}>
                    <Transition
                      show={!!userData && activeStep === 0}
                      appear
                      as={Fragment}
                      enter="ease-out transition-opacity delay-[2250ms] duration-[6000ms]"
                      enterFrom="opacity-0 absolute"
                      enterTo="opacity-100 absolute"
                      leave="ease-in duration-500"
                      leaveFrom="opacity-100 absolute"
                      leaveTo="opacity-0 absolute"
                    >
                      <div className={`text-xl sm:text-3xl font-medium`}>
                        Please provide a few details to get your account started
                      </div>
                    </Transition>
                    <Transition
                      show={!!userData && activeStep === 1}
                      appear
                      as={Fragment}
                      enter="ease-out transition-opacity delay-1000 duration-[6000ms]"
                      enterFrom="opacity-0 absolute"
                      enterTo="opacity-100 absolute"
                      leave="ease-in duration-500"
                      leaveFrom="opacity-100 absolute"
                      leaveTo="opacity-0 absolute"
                    >
                      <div className={`text-xl font-medium`}>
                        {/* @ts-ignore */}
                        Let's verify your account
                      </div>
                    </Transition>
                    <Transition
                      show={!!userData && activeStep === 2}
                      appear
                      as={Fragment}
                      enter="ease-out transition-opacity delay-1000 duration-[6000ms]"
                      enterFrom="opacity-0 absolute"
                      enterTo="opacity-100 absolute"
                      leave="ease-in duration-500"
                      leaveFrom="opacity-100 absolute"
                      leaveTo="opacity-0 absolute"
                    >
                      <div className={`text-3xl font-medium`}>
                        {/* @ts-ignore */}
                        Get a number for {methods.watch('companyName')}
                      </div>
                    </Transition>
                  </div>
                </div>
              </div>
              <div
                className={`sm:flex hidden h-10 text-sm w-full space-x-4 items-end`}
              >
                <div>© CallingIO 2023</div>
                <div>Terms of service</div>
                <div>Privacy</div>
              </div>
            </div>
            <div
              className={`sm:w-1/2 flex-[6] sm:flex-1 sm:p-24 p-10 pb-2 flex overflow-y-auto min-h-0 flex-col justify-between`}
            >
              <Transition
                as={Fragment}
                enter="ease-in transition-opacity delay-[2750ms] duration-[1500ms]"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-500"
                leaveFrom="opacity-100 "
                leaveTo="opacity-0"
                appear
                show={!!userData && activeStep !== 3}
              >
                <div
                  // TODO: remove "hidden" from below to show the timeline/steps!
                  className={`hidden w-full flex space-x-5 items-center justify-center`}
                >
                  <StepTab
                    icon={<UserIcon fr={undefined} height={16} width={16} />}
                    label={'Company Details'}
                    step={0}
                    // @ts-ignore
                    currentStep={activeStep}
                    //@ts-ignore
                    onClick={() => methods.setValue('activeStep', 0)}
                  />
                  <div
                    className={`flex-grow h-[1px] bg-neutral-20 rounded-full`}
                  ></div>

                  <StepTab
                    icon={
                      <CreditCardIcon fr={undefined} height={16} width={16} />
                    }
                    label={'Verify Card'}
                    step={1}
                    // @ts-ignore
                    currentStep={activeStep}
                    onClick={
                      !methods.formState.isValid ||
                      // @ts-ignore
                      !methods.watch('companyName', '').length
                        ? undefined
                        : // @ts-ignore
                          () => methods.setValue('activeStep', 1)
                    }
                  />
                  <div
                    className={`flex-grow h-[1px] bg-neutral-20 rounded-full`}
                  ></div>
                  <StepTab
                    icon={<PhoneIcon fr={undefined} height={16} width={16} />}
                    label={'Get phone number'}
                    step={2}
                    // @ts-ignore
                    currentStep={activeStep}
                    onClick={
                      !methods.formState.isValid ||
                      // @ts-ignore
                      !methods.watch('verified')
                        ? undefined
                        : // @ts-ignore
                          () => methods.setValue('activeStep', 2)
                    }
                  />
                </div>
              </Transition>

              {/* @ts-ignore */}
              <Transition
                as={Fragment}
                enter="ease-in transition-opacity delay-[2750ms] duration-[1500ms]"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-500"
                leaveFrom="opacity-100 "
                leaveTo="opacity-0"
                appear
                show={!!userData}
              >
                <div
                  className={`relative flex-grow w-full grid place-items-center`}
                >
                  <Transition
                    as={Fragment}
                    enter="ease-out transition-all delay-500 duration-[1000ms]"
                    enterFrom="opacity-0 -translate-x-[36rem]"
                    enterTo="opacity-100"
                    leave="ease-in duration-500"
                    leaveFrom="opacity-100 absolute "
                    leaveTo="opacity-0 -translate-x-[36rem] absolute"
                    appear
                    show={activeStep === 0}
                    unmount={false}
                  >
                    <div className={`w-full`}>
                      <Step1 user={userData} />
                    </div>
                  </Transition>
                  <Transition
                    unmount={false}
                    as={Fragment}
                    enter="ease-out transition-all delay-500 duration-[1000ms]"
                    enterFrom={`opacity-0 ${
                      prevStep < activeStep
                        ? 'translate-x-[36rem]'
                        : '-translate-x-[36rem]'
                    } absolute`}
                    enterTo="opacity-100 absolute"
                    leave="ease-in duration-500 absolute"
                    leaveFrom="opacity-100 absolute"
                    leaveTo={`opacity-0 absolute ${
                      prevStep < activeStep
                        ? '-translate-x-[36rem]'
                        : 'translate-x-[36rem]'
                    }`}
                    appear
                    show={activeStep === 1}
                  >
                    <div className={`w-full`}>
                      <Step2 />
                    </div>
                  </Transition>
                  <Transition
                    as={Fragment}
                    enter="ease-out transition-all delay-500 duration-[1000ms]"
                    enterFrom="opacity-0 translate-x-[36rem] absolute"
                    enterTo="opacity-100 absolute"
                    leave="ease-in duration-500 absolute"
                    leaveFrom="opacity-100 absolute"
                    leaveTo="opacity-0 absolute translate-x-[36rem]"
                    appear
                    show={activeStep === 2}
                  >
                    <div className={`w-full`}>
                      <Step3 user={userData} />
                    </div>
                  </Transition>
                  <Transition
                    as={Fragment}
                    enter="ease-out transition-all delay-500 duration-[1000ms]"
                    enterFrom="opacity-0 translate-x-[36rem] absolute"
                    enterTo="opacity-100 absolute"
                    leave="ease-in duration-500 absolute"
                    leaveFrom="opacity-100 absolute"
                    leaveTo="opacity-0 absolute translate-x-[36rem]"
                    appear
                    show={activeStep === 3}
                  >
                    <div className={`w-full`}>
                      <CompleteScreen />
                    </div>
                  </Transition>
                </div>
              </Transition>
              <div
                className={`flex sm:hidden h-10 text-sm w-full space-x-4 items-end`}
              >
                <div>© CallingIO 2023</div>
                <div>Terms of service</div>
                <div>Privacy</div>
              </div>
              <div className={`sm:block hidden h-10 w-full`}></div>
            </div>
          </div>
        </Transition>
      </form>
    </FormProvider>
  );

  // return (
  //   <Container sx={{ mt: 5, mb: 5, width: 740 }}>
  //     <FormProvider {...methods}>
  //       <form>
  //         <Box>
  //           <div className="text-2xl text-center mb-4">
  //             Welcome, {userData?.doc?.first_name}!
  //           </div>
  //           <Box sx={{ width: '100%', mt: 4, mb: 4 }}>
  //             {/* @ts-ignore */}
  //             <Stepper activeStep={activeStep}>
  //               <Step completed>
  //                 <StepLabel>Basic Details</StepLabel>
  //               </Step>
  //               <Step>
  //                 <StepLabel>Select Phone Number</StepLabel>
  //               </Step>
  //               <Step>
  //                 <StepLabel>Done!</StepLabel>
  //               </Step>
  //             </Stepper>
  //           </Box>
  //           {/* @ts-ignore */}
  //           {activeStep === 0 ? <Step1 /> : null}
  //           {/* @ts-ignore */}
  //           {activeStep === 1 ? <Step3 user={userData} /> : null}
  //           {/* @ts-ignore */}
  //           {activeStep === 2 ? <Step3 /> : null}
  //         </Box>
  //       </form>
  //     </FormProvider>
  //   </Container>
  // );
};

// const StepPanel = ({
//   children,
//   currentStep,
//   step,
// }: {
//   children: ReactNode;
//   currentStep: number;
//   step: number;
// }) => {
//   return (
//     <Transition
//       appear
//       show={currentStep === step}
//       as={Fragment}
//       enter="ease-in transition-opacity delay-[8000ms] duration-[5000ms]"
//       enterFrom="opacity-0"
//       enterTo="opacity-100 translate-x-0"
//       leave="ease-in duration-500"
//       leaveFrom="opacity-100 "
//       leaveTo="opacity-0"
//     >
//       <div className={`w-full`}>{children}</div>
//     </Transition>
//   );
// };

const CompleteScreen = () => {
  const [{ openTour }] = useGlobalTour();
  return (
    <div className={`w-full flex flex-col space-y-8`}>
      <div className={`w-full text-center text-xl`}>You're all set up!</div>
      <Button
        size={'lg'}
        variant={'fill'}
        color={'accent'}
        className={`w-full`}
        // component={Link}
        // to={'/'}
        onClick={() => openTour('setup2')}
      >
        Get started
      </Button>
    </div>
  );
};

export const StepTab = ({
  label,
  icon,
  currentStep,
  step,
  onClick,
  link,
}: {
  link?: boolean;
  label: string;
  icon: ReactElement;
  currentStep: number;
  step: number;
  onClick?: () => void;
}) => {
  const isActive = step === currentStep;
  return (
    <div
      onClick={onClick}
      className={`${
        onClick ? 'cursor-pointer' : ''
      } flex space-x-2 items-center`}
    >
      <div
        className={`rounded-full transition-colors duration-[1500ms] ease-in-out ${
          isActive ? 'bg-accent-60 text-white' : 'bg-neutral-20 text-neutral-60'
        } p-2`}
      >
        {icon}
      </div>
      <div
        className={`font-medium ${
          link ? 'underline !text-accent-60' : ''
        } text-md transition-colors duration-[1500ms] ease-in-out ${
          isActive ? 'text-neutral-90' : 'text-neutral-60 sm:block hidden'
        }`}
      >
        {label}
      </div>
    </div>
  );
};

export default Vsb;
